import { render, staticRenderFns } from "./PaymentCheckoutSectionInstance.vue?vue&type=template&id=0084ba73&"
import script from "./PaymentCheckoutSectionInstance.vue?vue&type=script&lang=js&"
export * from "./PaymentCheckoutSectionInstance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanels})
